import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface GlowCardProps {
  children: ReactNode;
  className?: string;
  glowColor?: string;
}

const GlowCard = ({ children, className, glowColor = 'primary' }: GlowCardProps) => {
  return (
    <div className={cn("relative group cursor-pointer", className)}>
      {/* Glow effect */}
      <div 
        className="absolute -inset-[2px] rounded-xl opacity-0 group-hover:opacity-75 transition-all duration-500 blur-lg scale-100 group-hover:scale-105"
        style={{
          background: `linear-gradient(135deg, hsl(var(--${glowColor})) 0%, hsl(var(--${glowColor}) / 0.3) 50%, hsl(var(--${glowColor})) 100%)`,
        }}
      />
      
      {/* Border glow */}
      <div 
        className="absolute -inset-[1px] rounded-xl opacity-30 group-hover:opacity-100 transition-all duration-300"
        style={{
          background: `linear-gradient(135deg, hsl(var(--${glowColor}) / 0.5) 0%, transparent 50%, hsl(var(--${glowColor}) / 0.5) 100%)`,
        }}
      />
      
      {/* Card content */}
      <div className="relative glass rounded-xl p-6 h-full transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-xl group-hover:shadow-primary/20">
        {children}
      </div>
    </div>
  );
};

export default GlowCard;
